import { SITE_BUILDER_AUTHORITATIVE_STYLE_CSS } from "./siteBuilderStyles";

export function WebBuilderRegionStyles() {
    return (
        <style>{`
            [data-web-builder-region] {
                max-width: 100%;
                min-width: 0;
            }

            [data-web-builder-region] .site-builder-booking-portal-page {
                max-width: 100%;
                min-width: 0;
                width: 100%;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-section:has(.site-builder-booking-portal) {
                background: var(--site-background) !important;
                min-height: calc(100svh - 80px) !important;
                padding: 0 !important;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) {
                gap: clamp(1.25rem, 3vw, 2.5rem) !important;
                grid-auto-rows: auto !important;
                max-width: none;
                width: 100%;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid-item:has(.site-builder-booking-portal) {
                grid-column: 1 / -1 !important;
                grid-row: auto !important;
                max-width: none;
                width: 100%;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-column:has(> .site-builder-booking-portal) > :not(.site-builder-booking-portal) {
                display: none;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:not(:has(.site-builder-booking-portal)) {
                display: none;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has([data-document-role="openingHoursTable"]) {
                display: block;
                grid-column: 1 / span 6 !important;
                grid-row: auto !important;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has(.site-builder-map) {
                display: block;
                grid-column: 7 / -1 !important;
                grid-row: auto !important;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has([data-document-role="openingHoursTable"]),
            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has(.site-builder-map) {
                align-self: stretch;
                margin-block: clamp(1.5rem, 4vw, 3.5rem);
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has(.site-builder-map) > .site-builder-column,
            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has(.site-builder-map) > .site-builder-column > [data-site-builder-block="map"] {
                height: 100%;
                min-height: 384px;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has(.site-builder-map) .site-builder-map {
                aspect-ratio: auto !important;
                height: 100% !important;
                min-height: 384px !important;
            }

            [data-web-builder-region] [data-document-role="bookingPortalSupportSection"] .site-builder-grid {
                align-items: stretch;
            }

            [data-web-builder-region] [data-document-role="bookingPortalSupportSection"] > .site-builder-grid > .site-builder-grid-item,
            [data-web-builder-region] [data-document-role="bookingPortalSupportSection"] > .site-builder-grid > .site-builder-grid-item > .site-builder-column {
                height: 100%;
            }

            [data-web-builder-region] [data-document-role="bookingPortalSupportSection"] > .site-builder-grid > .site-builder-grid-item > .site-builder-column > [data-site-builder-block="map"] {
                height: 100%;
                min-height: 384px;
            }

            [data-web-builder-region] [data-document-role="bookingPortalSupportSection"] .site-builder-map {
                aspect-ratio: auto !important;
                height: 100% !important;
                min-height: 384px !important;
            }

            [data-web-builder-region] [data-document-role="openingHoursTable"] > .site-builder-column-inline {
                align-items: center !important;
                flex-direction: row !important;
                width: 100%;
            }

            [data-web-builder-region] [data-document-role="openingHoursTable"] > .site-builder-column-inline > [data-site-builder-block="text"] {
                flex: 1 1 calc(50% - 6px);
                min-width: 0;
            }

            [data-web-builder-region] [data-document-role="openingHoursTable"] > .site-builder-column-inline > [data-site-builder-block="text"] > .site-builder-text {
                overflow-wrap: normal !important;
                white-space: nowrap !important;
                width: 100% !important;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-column:has(.site-builder-booking-portal) {
                background: transparent !important;
                border: 0 !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                max-width: none;
                padding: 0 !important;
                width: 100%;
            }

            [data-web-builder-region] .site-builder-booking-portal-page .site-builder-booking-portal {
                background: transparent !important;
                border: 0 !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                max-width: none;
                padding: 0 !important;
                width: 100%;
            }

            [data-web-builder-region] .site-builder-section {
                container-name: site-builder-section;
                container-type: inline-size;
                max-width: 100%;
                min-width: 0;
                position: relative;
            }

            [data-web-builder-region] .site-builder-grid {
                width: min(100%, var(--site-container));
                max-width: 100%;
                min-width: 0;
                margin-inline: auto;
                display: grid;
                gap: clamp(1rem, 2.4vw, 2rem);
            }

            [data-web-builder-region] .site-builder-grid-item {
                min-width: 0;
                max-width: 100%;
            }

            [data-web-builder-region] .site-builder-grid > *,
            [data-web-builder-region] .site-builder-column > *,
            [data-web-builder-region] .site-builder-column-group > *,
            [data-web-builder-region] .site-builder-card-content > *,
            [data-web-builder-region] .site-builder-form-fields > * {
                max-width: 100%;
                min-width: 0;
            }

            [data-web-builder-region] .site-builder-grid:not(.site-builder-grid-placed) {
                grid-template-columns: repeat(12, minmax(0, 1fr));
            }

            [data-web-builder-region] .site-builder-grid:not(.site-builder-grid-placed) > .site-builder-grid-item {
                grid-column: 1 / -1;
            }

            /*
             * Template skins may shape their initial composition with
             * role-based !important rules. Above the shared mobile breakpoint,
             * the persisted 12-column placement is authoritative so a builder
             * move or resize always changes the rendered site as well.
             */
            @container site-builder-section (min-width: 901px) {
                [data-web-builder-region] .site-builder-section > .site-builder-grid.site-builder-grid-placed[data-site-builder-authored-grid-columns="true"] {
                    grid-template-columns: var(--site-builder-authored-grid-columns) !important;
                }

                [data-web-builder-region] .site-builder-section > .site-builder-grid.site-builder-grid-placed[data-site-builder-authored-grid-rows="true"] {
                    grid-auto-rows: var(--site-builder-authored-grid-rows) !important;
                }

                [data-web-builder-region] .site-builder-section > .site-builder-grid.site-builder-grid-placed > .site-builder-grid-item[data-site-builder-authored-grid-column="true"] {
                    grid-column: var(--site-builder-authored-grid-column) !important;
                }

                [data-web-builder-region] .site-builder-section > .site-builder-grid.site-builder-grid-placed > .site-builder-grid-item[data-site-builder-authored-grid-row="true"] {
                    grid-row: var(--site-builder-authored-grid-row) !important;
                }
            }

            [data-web-builder-region] .site-builder-column {
                display: grid;
                align-content: start;
                gap: 1rem;
                max-width: 100%;
                min-width: 0;
            }

            [data-web-builder-region] .site-builder-column-inline {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
            }

            [data-web-builder-region] .site-builder-form-fields {
                grid-template-columns: repeat(var(--site-form-columns, 1), minmax(0, 1fr));
                max-width: 100%;
                min-width: 0;
            }

            [data-web-builder-region] .site-builder-text,
            [data-web-builder-region] .site-builder-form-title,
            [data-web-builder-region] .site-builder-form-text,
            [data-web-builder-region] .site-builder-form-field,
            [data-web-builder-region] .site-builder-card-title,
            [data-web-builder-region] .site-builder-card-text,
            [data-web-builder-region] .site-builder-blockquote,
            [data-web-builder-region] .site-builder-content-list,
            [data-web-builder-region] .site-builder-cta-title,
            [data-web-builder-region] .site-builder-cta-label,
            [data-web-builder-region] .site-builder-navigation-link {
                max-width: 100%;
                min-width: 0;
                overflow-wrap: anywhere;
            }

            [data-web-builder-region] .site-builder-text {
                color: inherit;
                font-family: var(--site-body-font);
                line-height: 1.65;
            }

            [data-web-builder-region] .site-builder-button {
                max-width: 100%;
                min-width: 0;
                overflow-wrap: anywhere;
                white-space: normal;
            }

            [data-web-builder-region] .site-builder-image,
            [data-web-builder-region] .site-builder-media-video,
            [data-web-builder-region] .site-builder-card-media {
                max-width: 100%;
                min-width: 0;
            }

            [data-web-builder-region] .site-builder-image,
            [data-web-builder-region] .site-builder-media-video {
                height: auto;
            }

            [data-web-builder-region] .site-builder-text-h1,
            [data-web-builder-region] .site-builder-text-h2,
            [data-web-builder-region] .site-builder-text-h3 {
                font-family: var(--site-heading-font);
                letter-spacing: -0.025em;
            }

            [data-web-builder-region] .site-builder-text-h1 {
                font-size: clamp(2.5rem, 12cqw, 4.5rem);
                line-height: 1.04;
            }

            [data-web-builder-region] .site-builder-text-h2 {
                font-size: clamp(2rem, 9cqw, 3.25rem);
                line-height: 1.1;
            }

            [data-web-builder-region] .site-builder-text-h3 {
                font-size: clamp(1.5rem, 6cqw, 2.25rem);
                line-height: 1.18;
            }

            @container (max-width: 639px) {
                [data-web-builder-region] .site-builder-form-fields {
                    grid-template-columns: minmax(0, 1fr) !important;
                }
            }

            @container site-builder-section (max-width: 767px) {
                [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has([data-document-role="openingHoursTable"]),
                [data-web-builder-region] .site-builder-booking-portal-page .site-builder-grid:has(.site-builder-booking-portal) > .site-builder-grid-item:has(.site-builder-map) {
                    grid-column: 1 / -1 !important;
                    margin: 0 clamp(1.125rem, 4vw, 2rem);
                }

                [data-web-builder-region] .site-builder-grid[data-site-builder-stack-on-mobile="true"] {
                    grid-template-columns: minmax(0, 1fr) !important;
                    grid-template-rows: none !important;
                    grid-auto-rows: auto !important;
                }

                [data-web-builder-region] .site-builder-grid[data-site-builder-stack-on-mobile="true"] > .site-builder-grid-item {
                    grid-column: 1 !important;
                    grid-row: auto !important;
                }

                [data-web-builder-region] .site-builder-footer-empty-extended-slot {
                    inset: auto !important;
                    height: auto !important;
                    min-height: 44px !important;
                    position: relative !important;
                    width: 100% !important;
                }

                [data-web-builder-region] .site-builder-column-inline[data-site-builder-stack-on-mobile="true"] {
                    align-items: stretch;
                    flex-direction: column;
                }

                [data-web-builder-region] .site-builder-column-group {
                    grid-template-columns: minmax(0, 1fr) !important;
                }
            }

            @container (max-width: 520px) {
                [data-web-builder-region] .site-builder-card-layout-left,
                [data-web-builder-region] .site-builder-card-layout-right {
                    grid-template-columns: minmax(0, 1fr) !important;
                }

                [data-web-builder-region] .site-builder-card-content-inline {
                    align-items: stretch !important;
                    flex-direction: column;
                }
            }

            @media (min-width: 901px) {
                ${SITE_BUILDER_AUTHORITATIVE_STYLE_CSS}
            }
        `}</style>
    );
}
